/**
 * Scroll-direction header state.
 *
 * Adds `.bleek-header--scrolled` while scrolling down; removes it on
 * scrolling up or reaching the top. What that class actually does is
 * decided in bleek-header.liquid's stylesheet: on mobile (<750px) it
 * translates the whole header out of view. Desktop keeps the fixed-height
 * bar from the design.
 *
 * The theme makes .page-wrapper the real scrolling element at >=990px
 * (see base.css) while `window` itself never scrolls there — that's also
 * why the header's sticky positioning has to live on the section wrapper
 * rather than a nested element. So scroll position has to be read from
 * whichever of the two is actually acting as the scroll container, and
 * listeners are attached to both since only one of them fires.
 *
 * State only flips once the scroll has moved past THRESHOLD px from where
 * it last flipped (rather than on every delta). This isn't just a small
 * safety margin: measured directly, a single continuous scroll gesture
 * reports a real back-and-forth position oscillation of ~25px (scroll
 * momentum/deceleration overshoot), so the threshold has to comfortably
 * clear that or the class — and the padding/transform it drives — flips
 * back and forth within one gesture, which reads as the header shaking.
 */
(function () {
  var header = document.querySelector('.bleek-header-wrapper');
  var pageWrapper = document.querySelector('.page-wrapper');
  if (!header) return;

  var THRESHOLD = 40;

  function getScrollY() {
    if (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight) {
      return pageWrapper.scrollTop;
    }
    return window.scrollY;
  }

  var committedScrollY = getScrollY();
  var ticking = false;

  function update() {
    var currentScrollY = getScrollY();
    var delta = currentScrollY - committedScrollY;

    if (currentScrollY <= 0) {
      header.classList.remove('bleek-header--scrolled');
      committedScrollY = currentScrollY;
    } else if (delta > THRESHOLD) {
      header.classList.add('bleek-header--scrolled');
      committedScrollY = currentScrollY;
    } else if (delta < -THRESHOLD) {
      header.classList.remove('bleek-header--scrolled');
      committedScrollY = currentScrollY;
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', onScroll, { passive: true });
  }
})();
